import React from 'react'
import ReactDOM from 'react-dom'
import App from './App';

import './index.sass'

const render = () => {
  try 
  {
    ReactDOM.render(<App />, document.getElementById("root"));
  } 
  catch (e) 
  {
    if (/Loading chunk [\d]+ failed/.test(e.message)) 
    {
      window.location.reload();
    }
  }
};
render();
